import React, { createContext, useState, useContext } from "react"
import { makeObservable, observable, action } from "mobx"
import dialogs, { customDialogs } from "./dialogs"
import DialogBase from "./base"

export class DialogStore {
  opened = false
  isCustom = false
  DialogComponent: React.FunctionComponent<any> | null = null
  props: any = {}

  constructor () {
    makeObservable(this, {
      opened: observable,
      isCustom: observable,
      DialogComponent: observable.ref,
      open: action.bound,
      close: action.bound
    })
  }

  open (dialogName: keyof typeof dialogs, props: any = {}) {
    this.DialogComponent = dialogs[dialogName]
    this.isCustom = customDialogs.includes(dialogName)
    this.props = props
    this.opened = true
  }

  close () {
    this.opened = false
  }
}

const StoreContext = createContext({} as DialogStore)

export const DialogStoreProvider = ({ children }: { children: React.ReactNode }) => {
  const [store] = useState(() => new DialogStore())

  return (
    <StoreContext.Provider value={store}>
      { children }
      <DialogBase store={store}/>
    </StoreContext.Provider>
  )
}

export const useDialogStore = () => {
  const store = useContext(StoreContext)
  return store
}
